import { colors } from "common/const/colors";

export const PaymentChannel = Object.freeze({
  ALL: "All",
  APP: "App",
  WEB: "Web",
  ON_SITE: "On-site",
});

export const PaymentCategory = Object.freeze({
  ALL: "All",
  FNB: "F&B",
  OTHER: "Other",
  RESERVATION: "Reservation",
});

export const PaymentMethod = Object.freeze({
  ALL: "All",
  CARD: "Card",
  CASH: "Cash",
  COMPLEX: "Complex",
  // ONLINE: "Online",
  // TRANSFER: "Transfer",
});

export const PaymentStatus = Object.freeze({
  APPROVED: { text: "Approved", color: colors.Green },
  CANCELLED: { text: "Cancelled", color: colors.Red },
  REFUND: { text: "Refund Pending", color: colors.LightNavy },
});

export const DiscountType = Object.freeze({
  COUPON: "Coupon",
  MEMBERSHIP: "Membership",
});

export const DiscountFilterType = Object.freeze({
  ALL: "All",
  APPLIED: "Discounted",
  NONE: "Not discounted",
});
